import { SimpleSearchField } from './simple-search-field';

export class SimpleSearch {
  fields: SimpleSearchField[];
  structureSearch: any;
}
